import axios from 'axios';
import { get } from '../../utils/http';

// Bare instance: the app default sends credentials, which S3 rejects on a signed URL.
const s3Client = axios.create();

// S3 answers with an XML body, which addResponseError cannot read - it would surface the raw axios
// "Request failed with status code 403".
const S3_ERROR_KEYS = {
  AccessDenied: 'reportSnapshotLinkExpired',
  ExpiredToken: 'reportSnapshotLinkExpired',
  NoSuchKey: 'reportSnapshotUnavailable'
};

export const fetchReportsHistory = ({ accountId, from, to }) =>
  get(`/accounts/${accountId}/reports-history`, { from, to });

export const fetchReportHistoryDownloadUrl = ({ accountId, reportHistoryId }) =>
  get(`/accounts/${accountId}/reports-history/${reportHistoryId}/download`);

export const fetchReportHistoryData = ({ accountId, reportHistoryId }) =>
  get(`/accounts/${accountId}/reports-history/${reportHistoryId}/data`);

export const fetchReportHistorySnapshot = async (url) => {
  try {
    const { data } = await s3Client.get(url, { withCredentials: false });
    return data;
  } catch (error) {
    const code = (String(error?.response?.data || '').match(/<Code>([^<]+)<\/Code>/) || [])[1];

    // addResponseError reads error.message, so the key has to travel as the message itself.
    const snapshotError = new Error(S3_ERROR_KEYS[code] || 'reportHistoryDataFetchFailed');
    snapshotError.cause = error;
    throw snapshotError;
  }
};
